

(function($) {
    
    let  loadingBundle = false;
    let  bundleLoaded = false;

    window._broker = languageAttributes.broker;
    window.tm_language = languageAttributes.name;

    function readcookie(a){a=new RegExp("(?:^| )"+a+"\x3d([^;]*)","i");return(a=document.cookie.match(a))&&2==a.length?a[1]:null; }


    function getcountrybroker(countrycode) {

        if (!countries || !countrycode)  return "";
        if (countries[countrycode].code == countrycode) return countries[countrycode].broker;
        
        return "";
    }


    function fbfBrokerConflict(){
        var country_code =readcookie("geoip");
        $.ajax({
            url: `https://content.webapi-services.net/api/allowedRegistrationCountries?b=${window._broker}`,
            dataType: 'json',
            success: function(countries) {
                if (country_code != null) {
                    if (countries && countries.indexOf(country_code) < 0 && $('#fbf_br_conflict_lightbox').length || country_code === 'IN') {
                        openLightBox('fbf_br_conflict_lightbox');

                    }
                }
            }
        })
       
    }

    if(!loadingBundle) {
        loadingBundle = true;
        if (!bundleLoaded) {
            const script = document.createElement('script');
            script.async = true;
            script.defer = true;
            script.src = '/registration-bundle-ext/iforex/'+languageAttributes.registrationBundle+'/main.js' +`?v=${BUILD_VERSION}`;


            script.onload = () => {
            
                fbfBrokerConflict();

            };
            loadingBundle = false;
            bundleLoaded = true;
            document.body.appendChild(script); 
        }
    }


	let fbfLoaded=false, loadingFBF = false, scrolling = false;

	function doScrolling() {
        if (!loadingFBF && !fbfLoaded ) {
            loadingFBF = true;
            !fbfLoaded && import(/* webpackChunkName: "fbf" */'./fbf')
                .then(() => {
                    loadingFBF = false;
                    fbfLoaded = true;
                });
		}
	}

    window.scrollingTasks.push(doScrolling);


 

})(window.jQuery);